// This is a temporary file
// It will be used from registration and my account profile update country list
// The list will eventually be stored in CMS
export const userCountryList = [
    {
        id: 6,
        name: 'Brazil',
        value: 'BR',
    },
    {
        id: 1,
        name: 'Malta',
        value: 'MT',
    },
    {
        id: 2,
        name: 'Spain',
        value: 'ES',
    },
    {
        id: 5,
        name: 'Thailand',
        value: 'TH',
    },
    {
        id: 3,
        name: 'United Kingdom',
        value: 'GB',
    },
    {
        id: 4,
        name: 'United States of America',
        value: 'US',
    },
];
